import React, {useState, useEffect} from 'react'
import '../Styles/ForgotPassPage.css'
import Color from '../../Components/Colors/Color'
import CustomSnackbar from "../Components/Snackbar/Snackbar"
import { handleLoginController, handleNewOtpController, handleOtpVerification } from '../Controller/LoginController';
import { useNavigate } from 'react-router-dom';
import '../Components/Overlay/Overlay.css'
import ClipLoader from "react-spinners/ClipLoader"

const ForgotPassPage = () => {

    const navigate = useNavigate();

    const [email, setEmail] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [tempOTP, setTempOTP] = useState(Array(4).fill("")); // Initialize with four empty strings
    const [finalOtp, setFinalOtp] = useState('');
    const [loading, setLoading] = useState(false);
    // const [isSignIn, setIsSignIn] = useState(true);
    const [showPassword, setShowPassword] = useState(false);
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [severitySnackbar, setSeveritySnackbar] = useState("");
    const [messageSnackbar, setMessageSnackbar] = useState("");
    const [success, setSuccess] = useState(false);
    const [finishFlag, setFinishFlag] = useState(false);
    const [snackbarDuration, setSnackbarDuration] = useState(0);
    const [showOverlay, setShowOverlay] = useState(false);
    const [emailFlag, setEmailFlag] = useState(false);
    const [forgotPassPage, setForgotPassPage] = useState(true);
    

    useEffect(() => {
        
        const email = localStorage.getItem('email');
        if(!openSnackbar && success){
            setForgotPassPage(false);
        }

        if(!openSnackbar && finishFlag){
            navigate('./reset-password')
        }

        if(!openSnackbar && emailFlag){
            setForgotPassPage(true);
        }

    }, [success && openSnackbar, finishFlag && openSnackbar, emailFlag && openSnackbar]) 

    useEffect(() => {
        if(!forgotPassPage){
            const email = localStorage.getItem('email');
            if(!email){
                setSeveritySnackbar("error");
                setMessageSnackbar("Please provide an email");
                setOpenSnackbar(true);
                setSnackbarDuration(2000);
                setSuccess(true);
                setEmailFlag(true);
            }
            document.getElementById(`otp-input-${0}`).focus();
        }

        if(forgotPassPage){
            setEmailFlag(false);
            localStorage.removeItem('email');
            sessionStorage.removeItem('otp');
        }
    }, [forgotPassPage])


    const handleLoginPage = (e) => {
        e.preventDefault();
        navigate("/admin");
    }

    const handleVerificationPage = (e) => {
        e.preventDefault();
        setForgotPassPage(page => !page);
    }

    const handleOtpChange = (e, index) => {
        const { value } = e.target;
        const numberOnly = value.replace(/\D/g, '');
        if (numberOnly.length > 1) return; // Only allow one digit

        const newTempOTP = [...tempOTP];
        newTempOTP[index] = numberOnly;
        setTempOTP(newTempOTP);

        if (newTempOTP.some((digit) => digit === "")) {
            setFinalOtp('');
        }
        

        // Move focus to next input if digit is entered
        if (numberOnly !== '' && index < 3) {
            document.getElementById(`otp-input-${index + 1}`).focus();
        }

        // Move focus to previous input if backspace is pressed and input is empty
        if (value === '' && index > 0) {
            document.getElementById(`otp-input-${index - 1}`).focus();
        }

        if (newTempOTP.every((digit) => digit !== "")) {
            setFinalOtp(newTempOTP.join(''));
        }
    };

    const handleOtpKeyDown = (e, index) => {
        const { key } = e;
        if (key === "Backspace" && !e.target.value && index > 0) {
            document.getElementById(`otp-input-${index - 1}`).focus();
        }
    };

    const handleOtpKeyEnter = (e) => {
        // e.preventDefault();
        if(e.key === 'Enter' && finalOtp){
            console.log('YES');
        }
    }

    const handleForgotPassword = async (e) => {
        e.preventDefault();

        if(!email) return;

        const emailRegex = /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
        var emailTest = emailRegex.test(email);

        if(!emailTest){
            setSeveritySnackbar("error");
            setMessageSnackbar("Invalid Email expression");
            setOpenSnackbar(true);
            setSnackbarDuration(2000);
            return;
        }

        try{
            setLoading(true);
            
            const response = await handleNewOtpController(email);

            const status = response?.status;

            console.log(status + 'Ola');

            if (status === 200) {

                setSeveritySnackbar("success");
                setMessageSnackbar("A one time password is sent to your email");
                setOpenSnackbar(true);
                setSnackbarDuration(3000);
                setSuccess(true);
                localStorage.setItem('email', email);
                console.log('Here');
                
            } else {
                setSeveritySnackbar("error");
                setMessageSnackbar(response?.data?.message || "An error has occured");
                setSuccess(false);
                setSnackbarDuration(3000);
                setOpenSnackbar(true);
            }
            
        }   catch (error) {
                setSeveritySnackbar("error");
                setMessageSnackbar(error?.response?.data?.message || "An error occurred, Please try again");
                setSuccess(false);
                setSnackbarDuration(3000);
                setOpenSnackbar(true);
        } finally{
            setLoading(false);
        }
    }

    const verifyOtp = async (e) => {
        e.preventDefault();

        if(!finalOtp){
            document.getElementById(`otp-input-${0}`).focus();
            
            setSeveritySnackbar("error");
            setMessageSnackbar("Enter the one time password");
            setOpenSnackbar(true);
            setSnackbarDuration(2000);
            return;
        } 

        const emailFound = localStorage.getItem('email');
        if(!emailFound){
            setSeveritySnackbar("error");
            setMessageSnackbar("Please provide an email");
            setOpenSnackbar(true);
            setSuccess(false)
            setEmailFlag(true);
            setSnackbarDuration(2000);
        } else{

            try{
                setLoading(true);
                

                const response = await handleOtpVerification(email, finalOtp);

                const status = response?.status;

                console.log(status + 'Ola');

                if (status === 200) {

                    const encryptedOtp = encryptOtp(finalOtp);
                    sessionStorage.setItem('otp', encryptedOtp);
                    setSeveritySnackbar("success");
                    setMessageSnackbar("Verification successful");
                    setOpenSnackbar(true);
                    setSnackbarDuration(3000);
                    setFinishFlag(true);
                    
                    console.log(encryptedOtp);
                    
                } else {
                    document.getElementById(`otp-input-${3}`).focus();
                    setSeveritySnackbar("error");
                    setMessageSnackbar(response?.data?.message || "An error has occured");
                    setSuccess(false);
                    setSnackbarDuration(3000);
                    setOpenSnackbar(true);
                }
                
            }   catch (error) {
                    setSeveritySnackbar("error");
                    setMessageSnackbar(error?.response?.data?.message || "An error occurred, Please try again");
                    setSuccess(false);
                    setSnackbarDuration(3000);
                    setOpenSnackbar(true);
            } finally{
                setLoading(false);
            }
        }
    }

    const encryptOtp = (otp) => {
        const multiplied = otp.split('').map(digit => (parseInt(digit) + 3));
        console.log(multiplied);
        const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        const shifted = multiplied.map(num => {
            let char = alphabet[(num) % 25]; // Convert number to alphabet letter (1-indexed)
            let shiftedIndex = (alphabet.indexOf(char) + 7) % 25; // Apply Caesar's cipher shift of 3
            return alphabet[shiftedIndex];
        });
        return shifted.join('');
    };

    const ResendOtp = (e) => {
        const emailFound = localStorage.getItem('email');
        if(!emailFound){
            setSeveritySnackbar("error");
            setMessageSnackbar("Please provide an email");
            setOpenSnackbar(true);
            setSnackbarDuration(2000);
            setEmailFlag(true);
        }else{
            setEmail(emailFound);
            handleForgotPassword(e);
        }
        
    }

    return(
        <>
            {forgotPassPage &&
            <div className="forgot-container" style={{backgroundColor: Color.secondaryBackground}}>
                <div className='forgot-card-container' style={{backgroundColor: Color.primaryBackground}}>
                    <div className='forgot-logo-container'>
                        <img src='/Images/logo.png' alt='opc-logo' className='forgot-logo' />
                    </div>
                    <div className='forgot-header-form-container'>
                        <div className='forgot-header-container'>
                            <h3 className='forgot-header'>
                                Forgot Password
                            </h3>
                        </div>

                        <form className='forgot-form-container' onSubmit={handleForgotPassword}>
                            <div className='forgot-label-input-container'>
                                <label htmlFor='email' className='forgot-label'>
                                    Email
                                </label>
                                <input
                                    type='email'
                                    id='email'
                                    className='forgot-input'
                                    placeholder='janedoe123@gmail.com'
                                    value={email}
                                    onChange={e => setEmail(e.target.value)}
                                    style={{color: Color.thirdText}}
                                    required
                                    />
                            </div>
                            <div className='forgot-form-forgot-container'>
                                    <button className='forgot-form-forgot-btn' onClick={handleLoginPage}>
                                        Back to Login?
                                    </button>
                                </div>
                            <div className='forgot-btn-container'>
                                <button type='submit' className='forgot-btn'>Send Otp</button>
                            </div>
                        </form>
                    </div>
                </div>
                <div className={`loading-container-overlay ${loading ? "" : "stop"}`}>
                    <ClipLoader size={100} color='white' />
                </div>
            </div>
}

            {!forgotPassPage &&
             <div className="forgot-container" style={{backgroundColor: Color.secondaryBackground}}>
                <div className='forgot-card-container' style={{backgroundColor: Color.primaryBackground}}>
                    
                    <div className='forgot-logo-container'>
                        <img src='/Images/logo.png' alt='opc-logo' className='forgot-logo' />
                    </div>

                    <div className='forgot-back-btn-container'>
                        <button className='forgot-back-btn' onClick={() => setForgotPassPage(true)}>
                            {'< Back'}
                        </button>
                    </div>

                    <div className='forgot-header-form-container'>
                        <div className='forgot-header-container'>
                            <h3 className='forgot-header'>
                                Verify Otp
                            </h3>
                        </div>

                        <form className='forgot-form-container' onSubmit={verifyOtp}>
                            <div className='verify-register-otp-input-container'>
                                {/* <label htmlFor='email' className='forgot-label'>
                                    Email
                                </label> */}
                                {tempOTP.map((otp, index) => (
                                            <input
                                                key={index}
                                                type="text"
                                                className="verify-register-otp-form-input"
                                                id={`otp-input-${index}`}
                                                maxLength={1}
                                                required
                                                onChange={(e) => handleOtpChange(e, index)}
                                                onKeyDown={(e) => handleOtpKeyDown(e, index)}
                                            
                                                value={otp}
                                            />
                                        ))}
                            </div>
                            <div className='forgot-btn-container otp'>
                                <button type='submit' className='forgot-btn'>Verify Otp</button>
                            </div>
                        </form>
                        <div className='login-register-btn-container'>
                            <div className='login-register-container'>
                                If you didn't receive a code, <span className='login-register-span' onClick={ResendOtp}>Resend</span> 
                            </div>
                        </div>
                    </div>
                    
                </div>
                <div className={`loading-container-overlay ${loading ? "" : "stop"}`}>
                    <ClipLoader size={100} color='white' />
                </div>
            </div>
}

            <CustomSnackbar
                severity={severitySnackbar}
                message={messageSnackbar}
                open={openSnackbar}
                onClose={() => setOpenSnackbar(false)}
                time= {snackbarDuration}
            />
        </>
    )
}

export default ForgotPassPage;